export default {
    namespaced: true,
    state: {
        currentQuestion: 1,
        information: null,
        privacyPolicyData: {}
    },
    mutations: {
        SET_CURRENT_QUESTION(state, step) {
            state.currentQuestion = step;
        },
        SET_INFORMATION(state, data) {
            state.information = data;
        },
        SET_PRIVACY_POLICY_DATA(state, data) {
            state.privacyPolicyData = data;
        }
    }
};
